if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.bindNavigation();
      }

      bindNavigation() {
        if (this.navBound) return;
        this.navBound = true;
        const prev = this.querySelector('.product-media-modal__nav--prev');
        const next = this.querySelector('.product-media-modal__nav--next');
        if (prev) prev.addEventListener('click', () => this.navigate(-1));
        if (next) next.addEventListener('click', () => this.navigate(1));
      }

      navigate(direction) {
        const items = Array.from(this.querySelectorAll('[data-media-id]')).filter((item) =>
          item.classList.contains('product-media-modal__model') === false || true
        );
        const activeIndex = items.findIndex((item) => item.classList.contains('active'));
        if (activeIndex === -1) return;
        let nextIndex = activeIndex + direction;
        if (nextIndex < 0) nextIndex = items.length - 1;
        if (nextIndex >= items.length) nextIndex = 0;
        items.forEach((item) => item.classList.remove('active'));
        items[nextIndex].classList.add('active');
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
